import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentLede";

export default function integrityCheck({
    items = [],
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);
    const [firstItem] = items || [];

    if (!firstItem) {
        return ["This module needs at least one valid item."];
    }

    messages.push(...checkMediaIntegrity([firstItem], MEDIA_PRIORITY));

    return messages;
}
